module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/man_ca21f5.png";